import { mqBanner, getBannerSize } from 'site/bannerSize/bannerSize';

export function getImageBannerStyle(heightSet, parallaxEffect = 'parallax') {
  const bannerSize = getBannerSize(heightSet);
  const staticBackground = parallaxEffect === 'fixed' || parallaxEffect === 'none';

  return {
    bannerHeight: mqBanner({
      height: bannerSize,
      backgroundPositionX: 'center',
      ...(staticBackground ? {
        backgroundSize: 'cover',
        backgroundPosition: 'center center'
      } : {})
    }),
    photoCredit: mqBanner({
      color: 'white',
      fontSize: '0.8rem',
      transform: 'rotate(-90deg) translate(-50%, 10px)',
      position: 'absolute',
      top: '50%',
      left: '0',
      textAlign: 'center',
      transformOrigin: 'left top',
      maxWidth: bannerSize.map(x => x * 0.9),
      '&:hover, &:active': {
        color: 'white'
      }
    })
  }
}
